import React from 'react'
import { useMutation } from 'react-query'

import axios from 'CanExConfig/axios'
import logo from '../../../assets/logo.png'

import styles from './styles'

const logOut = async () => {
  await axios('/users/sign_out', {
    method: 'DELETE',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
}

const Header = () => {
  const { mutateAsync: logOutMutation } = useMutation('logOut', logOut, {
    onSuccess: () => {
      window.location = '/'
    },
  })

  return (
    <header className={styles.container}>
      <div className={styles.inner}>
        <a href="/" className={styles.logo}>
          <img src={logo} alt="offerzen-logo" width={130} />
        </a>
        <button onClick={logOutMutation} type="button" className={styles.logOutButton}>
          Log out
        </button>
      </div>
    </header>
  )
}

export default Header
